//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Menu from "./Footer/Menu";
//Install
import Social from "./Footer/Social";
//Install
import Copyright from "./Footer/Copyright";
//Install
import Corporation from "./Footer/Corporation";

//Element
class Footer extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("footer", { className: "S6pt64 C96Q4r pEO064 a527eB u3v98z" },
            //Element
            React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB p943pc" },
                //Element
                React.createElement(Container, {},
                    //Element
                    React.createElement(Row, {},
                        //Element
                        React.createElement(Col, { md: 3 },
                            //Element
                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i59n11" },
                                //Element
                                React.createElement("h6", { className: "S6pt64 C96Q4r pEO064 a527eB o352hu" },
                                    //Element
                                    "Corporate"
                                ),
                                //Element
                                React.createElement(Corporation, {})
                            )
                        ),
                        //Element
                        React.createElement(Col, { md: 3 },
                            //Element
                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i59n11" },
                                //Element
                                React.createElement("h6", { className: "S6pt64 C96Q4r pEO064 a527eB o352hu" },
                                    //Element
                                    "Services"
                                ),
                                //Element
                                React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB rj401n" },
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/en/lighting-systems" },
                                            //Element
                                            "Lighting Systems"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/en/electrical-panel-manufacturing" },
                                            //Element
                                            "Electrical Panel Manufacturing"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/en/electrical-contracting" },
                                            //Element
                                            "Electrical Contracting"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/en/renewable-energy" },
                                            //Element
                                            "Renewable Energy"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/en/medium-voltage-systems" },
                                            //Element
                                            "Medium Voltage Systems"
                                        )
                                    )
                                )
                            )
                        ),
                        //Element
                        React.createElement(Col, { md: 3 },
                            //Element
                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i59n11" },
                                //Element
                                React.createElement("h6", { className: "S6pt64 C96Q4r pEO064 a527eB o352hu" },
                                    //Element
                                    "References"
                                ),
                                //Element
                                React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB rj401n" },
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/en/projects" },
                                            //Element
                                            "Borusan"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/en/projects" },
                                            //Element
                                            "Kanyon"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/en/projects" },
                                            //Element
                                            "Arçelik"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/en/projects" },
                                            //Element
                                            "Vestel"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/en/projects" },
                                            //Element
                                            "Eczacıbaşı"
                                        )
                                    )
                                )
                            )
                        ),
                        //Element
                        React.createElement(Col, { md: 3 },
                            //Element
                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i59n11" },
                                //Element
                                React.createElement("h6", { className: "S6pt64 C96Q4r pEO064 a527eB o352hu" },
                                    //Element
                                    "Contact Information"
                                ),
                                //Element
                                React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB rj401n" },
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/en/contact" },
                                            //Element
                                            "Contact"
                                        )
                                    )
                                )
                            )
                        ),
                        //Element
                        React.createElement(Col, { md: 3 },
                            //Element
                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i59n11" },
                                //Element
                                React.createElement("h6", { className: "S6pt64 C96Q4r pEO064 a527eB o352hu" },
                                    //Element
                                    "Follow"
                                ),
                                //Element
                                React.createElement(Social, {})
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB g3i234" },
                //Element
                React.createElement(Container, {},
                    //Element
                    React.createElement(Row, {},
                        //Element
                        React.createElement(Col, { md: 8 },
                            //Element
                            React.createElement(Copyright, { ID: "0", Title: "Copyright © 2025 Temas Electrical Contracting. All Rights Reserved." })
                        ),
                        //Element
                        React.createElement(Col, { md: 4 },
                            //Element
                            React.createElement(Menu, {})
                        )
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Footer;